import React, { useState, useEffect } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Button, Icon, Select } from '../../../components';
import { Globals, axios, Constants } from '../../../utils';
import Env from '../../../utils/env';
import moment from 'moment';
import { SizeColorForm } from './modal-products';

const ModalPromotedProducts = ({ show, onHide, user, onSelectProduct, defaultWarehouseId, warehouses, formatWarehouses }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [warehouseId, setWarehouseId] = useState(defaultWarehouseId || "");
    const [selectedOptions, setSelectedOptions] = useState({});

    const [warehouseProducts, setWarehouseProducts] = useState([]);

    useEffect(() => {
        if (show && user?.id) {
            loadData();
            if (defaultWarehouseId) setWarehouseId(defaultWarehouseId);
        }
    }, [show, user?.id, defaultWarehouseId]);

    useEffect(() => {
        if (warehouseId && user?.id) {
            fetchWarehouseProducts(warehouseId);
        }
    }, [warehouseId, user?.id]);

    const fetchWarehouseProducts = async (id) => {
        try {
            const data = {
                web: true,
                user_id: user.id,
                is_select: true,
                warehouse_id: id,
                with_products: true,
                unique_by_size_color: true,
            };
            const res = await axios.post('web/admin/warehouses', data);
            if (res.data && res.data.warehouses && res.data.warehouses.length > 0) {
                const selected = res.data.warehouses[0];
                setWarehouseProducts(selected.products || []);
            } else {
                setWarehouseProducts([]);
            }
        } catch (err) {
            console.error('Error fetching warehouse products:', err);
            setWarehouseProducts([]);
        }
    };

    const loadData = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`admin/inventory/products-promoted/list?page=1`, {
                user_id: user.id
            });
            if (res.data.result) {
                let allProducts = [];
                res.data.data.data.forEach(campaign => {
                    if (campaign.products && campaign.products.length > 0) {
                        campaign.products.forEach(p => {
                            if (p.product) {
                                allProducts.push({
                                    ...p.product,
                                    campaign_start: campaign.start_date,
                                    campaign_end: campaign.end_date,
                                });
                            }
                        });
                    }
                });
                setData(allProducts);
            }
        } catch (error) {
            console.error('ModalPromotedProducts -> loadData:', error);
        }
        setLoading(false);
    };

    const handleAdd = (product) => {
        if (!warehouseId) {
            Globals.showError("Debe seleccionar un almacén");
            return;
        }

        if (warehouseProducts) {
            const exists = warehouseProducts.find(wp => wp.product_id == product.id);
            if (!exists) {
                Globals.showError(`El producto ${product.name} no se encuentra disponible en el almacén seleccionado.`);
                return;
            }
            // Optional: Check if stock is > 0
            const totalStock = warehouseProducts
                .filter(wp => wp.product_id == product.id)
                .reduce((acc, wp) => acc + (wp.total_quantity || 0), 0);
            
            if (totalStock <= 0) {
                Globals.showError(`El producto ${product.name} no tiene stock disponible en el almacén seleccionado.`);
                return;
            }
            
            product.total_quantity = totalStock;
            product.stock = totalStock;
        }

        let defaultPrice = parseFloat(product.sale_price || product.price || 0);
        let variantStock = product.total_quantity || product.stock || 0;
        let selectedSize = null;
        let selectedColor = null;
        let altName = product.name;

        if (product.type === "SIZE_COLOR" || product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
            const options = selectedOptions[product.id] || {};
            let colors = [];
            let sizes = [];
            if (product.size_colors && product.size_colors.length > 0) {
                colors = [...product.size_colors.filter(i => i.color_id).reduce((prev, curr) => prev.set(curr.color_id, curr.color), new Map()).values()];
                sizes = [...product.size_colors.filter(i => i.size_id).reduce((prev, curr) => prev.set(curr.size_id, curr.size), new Map()).values()];
            }

            if (colors.length > 0 && !options.color_id) return Globals.showError('Debe seleccionar un color para ' + product.name);
            if (sizes.length > 0 && !options.size_id) return Globals.showError('Debe seleccionar una talla para ' + product.name);

            const variant = product.size_colors.find(sc => 
                (sizes.length > 0 ? sc.size_id === options.size_id : true) && 
                (colors.length > 0 ? sc.color_id === options.color_id : true)
            );

            if (variant) {
                defaultPrice = parseFloat(variant.sale_price || variant.price || 0);
                variantStock = variant.stock;
                selectedSize = variant.size_id;
                selectedColor = variant.color_id;

                if (variant.color && variant.color.name) altName += `, ${variant.color.name}`;
                if (variant.size && variant.size.name) altName += `, ${variant.size.name}`;
            } else {
                return Globals.showError('Variante no encontrada para ' + product.name);
            }
        }

        const formatted = {
            ...product,
            name: altName,
            product_id: product.id,
            quantity: 1,
            stock: variantStock,
            total_quantity: variantStock,
            subtotal: defaultPrice,
            discount: 0,
            warehouse_id: warehouseId,
            price: defaultPrice,
            sale_price: defaultPrice,
            selected_price: defaultPrice,
        };

        if (selectedSize) formatted.size_id = selectedSize;
        if (selectedColor) formatted.color_id = selectedColor;

        onSelectProduct(formatted, warehouseId);
        Globals.showSuccess("Producto agregado");
    };

    return (
        <BModal show={show} onHide={onHide} centered size="md">
            <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <h5 style={{ fontWeight: 'bold', margin: '0', color: '#333' }}>PRODUCTOS A PROMOVER</h5>
                    <p style={{ color: '#777', fontSize: '14px', margin: '5px 0 0 0' }}>Estos son los productos que debes promover</p>
                </div>
            </BModal.Header>
            <BModal.Body style={{ padding: '20px' }}>
                {(warehouses && warehouses.length > 1 && (user?.level_id == Constants.ROLE_ADMIN || (user?.level_id == Constants.ROLE_MODERATOR && user?.warehouse_id === null))) && (
                    <div style={{ marginBottom: '20px' }}>
                        <Select
                            label="Almacén"
                            labelClass="material"
                            disabledFirst
                            value={warehouseId}
                            options={formatWarehouses}
                            onChange={e => setWarehouseId(e.target.value)}
                        />
                    </div>
                )}
                
                {loading ? (
                    <div className="text-center" style={{ margin: '30px 0' }}><div className="loader" style={{ display: 'inline-block' }} /></div>
                ) : (
                    <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                        {data.map((product, index) => {
                            let displayProduct = product;
                            if (product.type === "SIZE_COLOR" || product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
                                if (warehouseProducts) {
                                    const wp = warehouseProducts.find(wp => wp.product_id == product.id);
                                    if (wp && wp.product && wp.product.size_colors) {
                                        displayProduct = { ...product, size_colors: wp.product.size_colors };
                                    }
                                }
                            }

                            return (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', padding: '15px 0', borderBottom: index < data.length - 1 ? '1px solid #eee' : 'none' }}>
                                <div style={{ width: '60px', height: '60px', marginRight: '15px', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#f9f9f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {product.photo?.file ? (
                                        <img src={`${Env.BaseStorage}${product.photo.file}`} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                        <Icon name="image" size="2x" color="#ccc" />
                                    )}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <h6 style={{ fontWeight: 'bold', margin: '0 0 5px 0', fontSize: '15px' }}>{product.name}</h6>
                                    <span style={{ color: '#0d6efd', fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '5px' }}>Periodo de campaña</span>
                                    <div style={{ color: '#555', fontSize: '13px', marginBottom: '10px' }}>
                                        <div>Desde {moment(product.campaign_start).format('DD-MM-YYYY')}</div>
                                        <div>Hasta {moment(product.campaign_end).format('DD-MM-YYYY')}</div>
                                    </div>
                                    {(displayProduct.type === "SIZE_COLOR" || displayProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) && (
                                        <div style={{ transform: 'scale(0.85)', transformOrigin: 'left top', marginTop: '-5px' }}>
                                            <SizeColorForm 
                                                product={{ 
                                                    ...displayProduct, 
                                                    size_id: selectedOptions[displayProduct.id]?.size_id, 
                                                    color_id: selectedOptions[displayProduct.id]?.color_id 
                                                }} 
                                                onChange={(val, target) => {
                                                    setSelectedOptions(prev => ({
                                                        ...prev,
                                                        [displayProduct.id]: {
                                                            ...(prev[displayProduct.id] || {}),
                                                            [target]: val
                                                        }
                                                    }));
                                                }} 
                                            />
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <Button color="primary" onClick={() => handleAdd(displayProduct)} style={{ padding: '6px 15px', fontSize: '13px', borderRadius: '5px' }}>
                                        AGREGAR
                                    </Button>
                                </div>
                            </div>
                        )})}
                        {data.length === 0 && (
                            <div className="text-center text-muted mt-4 mb-4">No hay productos a promover activos.</div>
                        )}
                    </div>
                )}

                <div style={{ backgroundColor: '#f4fbff', color: '#0d6efd', padding: '15px', borderRadius: '8px', textAlign: 'center', marginTop: '20px', fontSize: '14px', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <Icon name="info-circle" /> ¡Recuerda hablar de estos productos con tus clientes!
                </div>

                <div className="text-center mt-4">
                    <Button style={{ backgroundColor: '#1b2a47', color: 'white', padding: '10px 40px', fontWeight: 'bold', borderRadius: '5px' }} onClick={onHide}>
                        CERRAR
                    </Button>
                </div>
            </BModal.Body>
        </BModal>
    );
};

export default ModalPromotedProducts;
